// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QIUmf9rrTzMUV2 {
  display: flex;
  position: fixed;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  overflow: auto;
  background: rgba(0, 0, 0, 0.75);
  scrollbar-gutter: stable both-edges;
}
@supports (height: 100dvh) {
  .QIUmf9rrTzMUV2 {
    width: 100dvw;
    height: 100dvh;
  }
}
@media print {
  .QIUmf9rrTzMUV2 {
    /* stylelint-disable-next-line declaration-no-important */
    display: block !important;
    /* stylelint-disable-next-line declaration-no-important */
    position: relative !important;
    /* stylelint-disable-next-line declaration-no-important */
    width: auto !important;
    /* stylelint-disable-next-line declaration-no-important */
    height: auto !important;
    /* stylelint-disable-next-line declaration-no-important */
    max-height: 100% !important;
    /* stylelint-disable-next-line declaration-no-important */
    overflow: scroll !important;
  }
}
.dR7_v9XBQKTza3 {
  position: relative;
  width: auto;
  margin: var(--ds-space-600, 48px) var(--ds-space-0, 0);
  background: transparent;
}
.dR7_v9XBQKTza3:focus {
  outline: none;
}
@media print {
  .dR7_v9XBQKTza3 {
    width: 100%;
    margin: var(--ds-space-0, 0);
  }
}
.ySQIVFZtJ_1G5J {
  align-items: flex-start;
}
.QcK0b6bt9yGCnk {
  align-items: center;
}
.iCwICuMIYzk5zL {
  align-items: flex-end;
}
.ehqozeZjYqrYu1 {
  background: var(--ds-blanket, #091e427d);
  -webkit-backdrop-filter: blur(2px);
          backdrop-filter: blur(2px);
}
@media only screen and (max-width: 750px) {
  .dR7_v9XBQKTza3 {
    width: 100%;
  }
}
@media only screen and (max-width: 600px), only screen and (max-width: 450px) {
  .dR7_v9XBQKTza3 {
    width: 100%;
    margin: var(--ds-space-0, 0);
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `QIUmf9rrTzMUV2`,
	"contents": `dR7_v9XBQKTza3`,
	"alignTop": `ySQIVFZtJ_1G5J`,
	"alignCenter": `QcK0b6bt9yGCnk`,
	"alignBottom": `iCwICuMIYzk5zL`,
	"effectBlur": `ehqozeZjYqrYu1`
};
export default ___CSS_LOADER_EXPORT___;
